import React, { useRef, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import AppRoute from "./utils/AppRoute";
import Headroom from "headroom.js";
import Scroll from "./utils/Scroll";
import AOS from "aos";
import "aos/dist/aos.css";

import { Helmet } from "react-helmet";
// Layouts

// Views
import Home from "./views/Home";
import Team from "./views/Team";
import Business from "./views/Business";
import Individual from "./views/Individual";

const App = () => {
  useEffect(() => {
    AOS.init({
      duration: 800,
      once: true,
      offset: 100,
      easing: "ease-out-cubic",
    });
  }, []);

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0, minimum-scale=1.0"
        />
        <meta http-equiv="X-UA-Compatible" content="ie=edge" />
        <title>IHM Golf Tournament</title>
        <meta
          name="description"
          content="All proceeds go to IHM Parish and Academy upcoming expansion projects."
        />
        <link
          rel="apple-touch-icon"
          sizes="180x180"
          href="/apple-touch-icon.png"
        />
        <link
          rel="icon"
          type="image/png"
          sizes="32x32"
          href="/favicon-32x32.png"
        />
        <link
          rel="icon"
          type="image/png"
          sizes="16x16"
          href="/favicon-16x16.png"
        />
        <link rel="manifest" href="/site.webmanifest" />
        <link rel="mask-icon" href="/safari-pinned-tab.svg" color="#5bbad5" />
        <meta name="msapplication-TileColor" content="#da532c" />
        <meta name="theme-color" content="#ffffff" />
        <meta name="theme-color" content="#ffffff"></meta>
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
        <link
          href="https://fonts.googleapis.com/css2?family=Barlow:wght@400;500;600&display=swap"
          rel="stylesheet"
        />
      </Helmet>

      <Router>
        <Scroll>
          <Routes>
            <Route exact path="/" element={<Home />}></Route>
            <Route exact path="/team" element={<Team />}></Route>
            <Route
              exact
              path="/individual-sign-up"
              element={<Individual />}
            ></Route>
            <Route exact path="/business" element={<Business />}></Route>
            <Route path="/*" element={<Home />}></Route>
          </Routes>
        </Scroll>
      </Router>
    </>
  );
};

export default App;
